import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import FourOptions from '../components/FourOptions';
import ContentSection from '../components/ContentSection';
import AboutRImage from '../components/AboutRImage';
import Footer from '../components/Footer';
import '../styles/App.css';
import HeroImage from '../assets/images/app/dashboard.png';

// App screenshots
import DashboardImg from '../assets/images/app/dashboard.png';
import MacrocycleImg from '../assets/images/app/macrocycle.png';
import PerformanceImg from '../assets/images/app/performance-tracker.png';
import DashboardWorkoutBlackImg from '../assets/images/app/Dashboard_and_workout_v2_black.png';
import FounderImg from '../assets/images/drops/Sam_Begin_1.jpg';

function Programs() {
  // Four personas section - at bottom
  const personasContent = {
    sectionTitle: (
      <>
        Built for <span style={{ color: 'red' }}>Your Journey</span>
      </>
    ),
    sectionDescription:
      "No matter where you're starting or where you're headed, our programs adapt to you.",
    options: [
      {
        title: 'Functional Strength',
        body: (
          <>
            <p><strong>For beginners, intermediates, and advanced</strong></p>
            <p>Build real-world strength you can use every day</p>
            <p>Progress at your own pace with daily guidance</p>
          </>
        ),
      },
      {
        title: 'Athletic Performance',
        body: (
          <>
            <p><strong>For athletes with seasons to prepare for</strong></p>
            <p>Train hard in the off-season, peak when it counts</p>
            <p>Structured phases that match your competition calendar</p>
          </>
        ),
      },
      {
        title: 'Recovery & Rehab',
        body: (
          <>
            <p><strong>For those working through injury or setback</strong></p>
            <p>Gradual, intentional progression back to full strength</p>
            <p>Track your recovery milestones along the way</p>
          </>
        ),
      },
      {
        title: 'Longevity & Mobility',
        body: (
          <>
            <p><strong>For staying active and capable for life</strong></p>
            <p>Balance strength, flexibility, and mobility</p>
            <p>Sustainable routines that fit your lifestyle</p>
          </>
        ),
      },
    ],
  };

  // What You Get section
  const featuresContent = {
    sectionTitle: (
      <>
        What You <span style={{ color: 'red' }}>Get</span>
      </>
    ),
    sectionDescription:
      'Everything you need to plan, track, and improve—all in one place.',
    items: [
      {
        title: 'Your Daily Training Dashboard',
        imageSrc: DashboardImg,
        imagePosition: 'right',
        body1: (
          <p>
            See exactly what to do today. Your dashboard shows your scheduled workouts, tracks your progress, and keeps you motivated with daily goals.
          </p>
        ),
      },
      {
        imagePosition: 'alternating',
        sections: [
          {
            subtitle: 'Intelligent Program Management',
            imageSrc: MacrocycleImg,
            imagePosition: 'right',
            body: 'Get a structured program that builds week over week. Add your own workouts or follow the plan. Mark sessions complete with one tap.',
          },
          {
            subtitle: 'Performance Insights',
            imageSrc: PerformanceImg,
            imagePosition: 'left',
            body: 'Track trends over 30 days. View charts showing distance, time, and consistency. Keep your streak alive and hit your weekly targets.',
          },
        ],
      },
      {
        title: 'All Your Workouts in One Place',
        imageSrc: DashboardWorkoutBlackImg,
        imagePosition: 'inside',
        body1: (
          <p>
            Strength training, running, swimming, cycling, recovery sessions—everything lives here. Navigate easily between your dashboard, calendar, workouts, and stats from any device.
          </p>
        ),
      },
    ],
  };

  return (
    <div className="home">
      <SEO
        title="Training Programs"
        description="A training platform that helps you plan, track, and improve—whether you're just starting out or chasing your next goal."
        image="/og-images/programs.png"
        path="/programs"
      />
      <Header />
      <main>
        <Hero
          backgroundImage={HeroImage}
          headerText={
            <>
              Training<br /><span style={{ color: 'red' }}>Programs</span>
            </>
          }
          paragraphText={
            <>
              <p>
                A training platform that helps you plan, track, and improve—whether you're just starting out or chasing your next goal.
              </p>
            </>
          }
          primaryButtonText="Learn More"
          primaryButtonLink="/periodization"
          secondaryButtonText="Download App"
          secondaryButtonLink="/app"
        />

        <ContentSection
          sectionTitle={featuresContent.sectionTitle}
          sectionDescription={featuresContent.sectionDescription}
          items={featuresContent.items}
          sectionClass="faq-sub-section"
          showNumbers={false}
        />

        <FourOptions
          sectionTitle={personasContent.sectionTitle}
          sectionDescription={personasContent.sectionDescription}
          options={personasContent.options}
        />

        <AboutRImage
          title={
            <>
              Our <span style={{ color: 'red' }}>Founder</span>
            </>
          }
          copy="Begin Strength was founded to bring structured, periodized training to athletes of all ages and starting points. Explore our programs or learn more about our story."
          imageSrc={FounderImg}
          primaryButtonText="Periodization"
          primaryButtonLink="/periodization"
          secondaryButtonText="About Us"
          secondaryButtonLink="/about"
        />

        <Footer />
      </main>
    </div>
  );
}

export default Programs;
